import { Button, Typography } from "antd";
import { ArrowRight, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph, Text } = Typography;

export function FinalCtaSection() {
  const navigate = useNavigate();

  return (
    <section className="landing-section final-cta">
      <Title level={2}>Still Reading? Here's The Truth.</Title>

      <Paragraph>
        Every day you wait is another day you're losing money, wasting time,
        and letting stress run your life. But it doesn't have to be this way.
      </Paragraph>

      <Paragraph>
        <Text strong>2,500+ salon owners</Text> have already made the switch.
        They're booking more clients, making more money, and finally getting
        their weekends back. <Text strong>You can too.</Text>
      </Paragraph>

      <div className="final-cta-box">
        <Title level={3}>Start Today, See Results Tomorrow</Title>
        <Paragraph>
          Most salon owners see their first booking within 24 hours. Many
          recover the monthly cost in the first week.
        </Paragraph>
        <div className="final-cta-checks">
          <Text><Check size={16} /> 14-day free trial</Text>
          <Text><Check size={16} /> No credit card needed</Text>
          <Text><Check size={16} /> Free data migration</Text>
        </div>
      </div>

      <Button
        type="primary"
        size="large"
        className="landing-primary-button"
        onClick={() => navigate("/register")}
      >
        Get Started Free - Risk Free <ArrowRight size={18} />
      </Button>

      <Paragraph type="secondary" className="landing-note">
        Join 2,500+ successful salon owners • Takes less than 10 minutes
      </Paragraph>
    </section>
  );
}
